import React from 'react';

interface TableProps {
  className?: string;
  children: React.ReactNode;
}

export function Table({ className = '', children }: TableProps) {
  return (
    <div className={`w-full ${className}`}>
      <table className="w-full border-collapse">{children}</table>
    </div>
  );
}

interface TableHeaderProps {
  className?: string;
  children: React.ReactNode;
}

export function TableHeader({ className = '', children }: TableHeaderProps) {
  return <thead className={className}>{children}</thead>;
}

interface TableBodyProps {
  className?: string;
  children: React.ReactNode;
}

export function TableBody({ className = '', children }: TableBodyProps) {
  return <tbody className={className}>{children}</tbody>;
}

interface TableRowProps {
  className?: string;
  children: React.ReactNode;
}

export function TableRow({ className = '', children }: TableRowProps) {
  return <tr className={`border-b hover:bg-gray-50 ${className}`}>{children}</tr>;
}

interface TableHeadProps {
  className?: string;
  children: React.ReactNode;
}

export function TableHead({ className = '', children }: TableHeadProps) {
  return (
    <th className={`px-4 py-3 text-left text-sm font-medium text-gray-700 bg-gray-50 ${className}`}>
      {children}
    </th>
  );
}

interface TableCellProps {
  className?: string;
  colSpan?: number;
  children: React.ReactNode;
}

export function TableCell({ className = '', colSpan, children }: TableCellProps) {
  return (
    <td className={`px-4 py-3 text-sm ${className}`} colSpan={colSpan}>
      {children}
    </td>
  );
}
